import React from 'react';
import Header from './Header';
import makeStyles from '@material-ui/core/styles/makeStyles';
import HighlightedTypography from './HighlightedTypography';
import { SECONDARY_COLOR } from '../constants';
import LocalDeliveryIcon from '../../../../images/features/local_delivery/local_delivery_icon.png';
import BackgroundImage from '../../../../images/features/local_delivery/background.jpg';
import TopImage from '../../../../images/features/local_delivery/top.png';
import TopSpImage from '../../../../images/features/local_delivery/top_sp.png';
import Typography from '@material-ui/core/Typography';
import TitleImage from '../../../../images/features/local_delivery/ttl1.png';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  top: {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center',
  },
  h1: {
    textAlign: 'center',
  },
  heroImage: {
    width: '90%',
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.up('md')]: {
      width: '65%',
    },
  },
  descriptions: {
    lineHeight: 2,
    fontSize: theme.typography.pxToRem(14),
    position: 'relative',

    padding: theme.spacing(0, 4),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 2),
      textAlign: 'center',
    },
  },
  content: {
    backgroundColor: SECONDARY_COLOR,

    paddingBottom: theme.spacing(15),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(10),
    },
  },
  containerTitle: {
    textAlign: 'center',
    padding: theme.spacing(3, 0),
  },
  title: {
    width: 240,
    [theme.breakpoints.up('sm')]: {
      width: 308,
    },
  },
  sentences: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  sentence: {
    display: 'inline',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  iconContainer: {
    position: 'absolute',
    right: '4%',
    transform: 'rotateZ(6deg)',

    bottom: -140,
    [theme.breakpoints.up('md')]: {
      bottom: -80,
    },
  },
  icon: {
    width: 150,
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
}));

const Hero = ({ authenticated }) => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  return (
    <>
      <div className={classes.top}>
        <Header authenticated={authenticated} />
        <Typography variant="h1" className={classes.h1}>
          <img
            src={match ? TopImage : TopSpImage}
            alt="地方の良さを再発見！真田・森田のローカルデリバリー 7ORDERがおてつたびを通じて、日本各地のお手伝いをするTV番組START!!"
            className={classes.heroImage}
          />
        </Typography>
      </div>
      <div className={classes.content}>
        <Typography variant="h2" className={classes.containerTitle}>
          <img
            src={TitleImage}
            alt="今、「地方」がアツイ！"
            className={classes.title}
          />
        </Typography>
        <div className={classes.descriptions}>
          <div className={classes.sentences}>
            <div className={classes.sentence}>
              <HighlightedTypography>
                「7ORDER」の真田佑馬さん、森田美勇人さん
              </HighlightedTypography>
              の二人が実際に各地を訪れ、
            </div>
            <div className={classes.sentence}>
              お手伝いする地域応援バラエティー番組が
              <HighlightedTypography>
                スペースシャワーTVプラスにて9/19(日)からスタート！
              </HighlightedTypography>
            </div>
          </div>
          <div className={classes.sentences}>
            <div className={classes.sentence}>
              人手不足を中心とした困りごとをお手伝いする事により、
            </div>
            <div className={classes.sentence}>
              報酬を得ながら旅行を楽しめるサービスを展開する
              <HighlightedTypography>
                「おてつたび」が番組に全面協力！
              </HighlightedTypography>
            </div>
          </div>
          <div className={classes.sentences}>
            <div className={classes.sentence}>
              「7ORDER」の二人がおてつたびによって地方の方々との交流をし、
            </div>
            <div className={classes.sentence}>
              観光名所や名物に頼らない
              <HighlightedTypography>
                本当の「地方創生」に取り組む方々を発信
              </HighlightedTypography>
              していきます。
            </div>
          </div>
          <div className={classes.iconContainer}>
            <img src={LocalDeliveryIcon} alt="" className={classes.icon} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
